module.exports = __webpack_public_path__ + "static/media/list-loading.d4157fe8.svg";